// import packages
import React, { useContext } from "react";
import { Button, TextField, Select, Stack } from "@shopify/polaris";

// import context
import { PrivateContext } from "lib/context";
import { withErrorBoundary } from "lib/hoc";
import constant from "lib/constant/constant";

// import helper
import { baseHelper } from "lib/helpers";

// import propsTypes
import { AdvanceItemProp } from "app/setup/modules/operator/features/commission/props";

const ProductMetafieldAdd = (props) => {
  const { count, updateVal, advancedValue, removeItem, uniqueVal, disableNameKey } = props;
  const {
    color: { RED },
  } = constant;
  const { cms = {} } = useContext(PrivateContext);

  const advanceValueOptions = [
    {
      label: cms("label.text"),
      value: "string",
    },
    {
      label: cms("label.number"),
      value: "number",
    },
    {
      label: cms("label.measurement"),
      value: "measurement",
    },
  ];

  const handlePlaceHolder = (value) => {
    const placeholder = {
      measurement: cms("placeholder.unit"),
      number: cms("placeholder.maxValue"),
      string: cms("placeholder.maxLength"),
    };
    return placeholder[value.contentType];
  };

  const handleInput = (value, prevValue, type) => {
    if (type === constant.NUMBER) {
      return (baseHelper.validatePositiveNumericValues(value) && value) || (value !== "" && prevValue) || "";
    }
    if (type === constant.STRING) {
      return (baseHelper.validateWholeNumber(value) && value) || (value !== "" && prevValue) || "";
    }
    if (type === constant.MEASUREMENT) {
      return (baseHelper.validateMeasurement(value) && value) || (value !== "" && prevValue) || "";
    }
    return prevValue || "";
  };

  const handleKeyValidation = (value, prevValue) => {
    return (baseHelper.validateCamelCase(value) && value) || (value !== "" && prevValue) || "";
  };

  const arr = Array.from(Array(count).keys());
  return arr.map((item, index) => {
    const advanceItem = advancedValue[item];
    const advanceItemValue = advanceItem.contentType;
    if (!advanceItem) {
      return null;
    }

    return (
      <div key={item}>
        <Stack wrap={false} key={item} spacing="extraTight" distribution="fillEvenly" alignment="center">
          <Stack.Item>
            <div className="table-input">
              <TextField
                required
                placeholder={cms("placeholder.display")}
                onChange={(val) => {
                  updateVal(constant.NAME, val, item);
                }}
                value={(advanceItem && advanceItem.name) || ""}
                onBlur={() => {
                  uniqueVal(constant.NAME, advanceItem.name, item);
                }}
              />
            </div>
          </Stack.Item>
          <Stack.Item>
            <div className="table-input">
              <TextField
                required
                placeholder={cms("placeholder.nameSpace")}
                onChange={(val) => {
                  updateVal(constant.NAMESPACE, val, item);
                }}
                onBlur={() => {
                  uniqueVal(constant.NAMESPACE, advanceItem.namespace, item);
                }}
                value={(advanceItem && advanceItem.namespace) || ""}
                disabled={!disableNameKey.includes(index)}
              />
            </div>
          </Stack.Item>
          <Stack.Item>
            <div className="table-input">
              <TextField
                required
                placeholder={cms("placeholder.key")}
                onChange={(val) => {
                  updateVal(constant.KEY, handleKeyValidation(val, (advanceItem && advanceItem.key) || ""), item);
                }}
                onBlur={() => {
                  uniqueVal(constant.KEY, advanceItem.key, item);
                }}
                value={(advanceItem && advanceItem.key) || ""}
                disabled={!disableNameKey.includes(index)}
              />
            </div>
          </Stack.Item>
          <Stack.Item>
            <div className="table-input">
              <Select
                options={advanceValueOptions}
                placeholder={cms("placeholder.contentType")}
                onChange={(val) => {
                  updateVal(constant.CONTENT_TYPE, val, item);
                }}
                value={(advanceItem && advanceItemValue) || ""}
              />
            </div>
          </Stack.Item>
          {advanceItem.contentType && (
            <Stack.Item>
              <div className="table-input">
                <TextField
                  required
                  placeholder={handlePlaceHolder(advanceItem)}
                  onChange={(val) => {
                    updateVal(
                      constant.VALUE,
                      handleInput(val, (advanceItem && advanceItem.value) || "", advanceItem.contentType),
                      item
                    );
                  }}
                  value={
                    advanceItem.contentType === constant.MEASUREMENT
                      ? (advanceItem && advanceItem.value && advanceItem.value.toString()) || ""
                      : (advanceItem && advanceItem.value) || ""
                  }
                />
              </div>
            </Stack.Item>
          )}
          <Stack.Item>
            <Button id="deleteButton" plain onClick={() => removeItem(item)}>
              <i className="far fa-trash fa-lg" style={{ color: RED }} />
            </Button>
          </Stack.Item>
        </Stack>
        <Stack.Item>
          <br />
        </Stack.Item>
      </div>
    );
  });
};

ProductMetafieldAdd.propTypes = AdvanceItemProp.type;

export default withErrorBoundary(ProductMetafieldAdd);
